import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange, maxVisiblePages = 5 }) => {
  const getVisiblePages = () => {
    // If total pages is less than or equal to max visible, show all
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const half = Math.floor(maxVisiblePages / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, start + maxVisiblePages - 1);

    // Adjust start if we're near the end
    if (end - start < maxVisiblePages - 1) {
      start = Math.max(1, end - maxVisiblePages + 1);
    }

    const pages = [];
        
    // Always show first page if not in range
    if (start > 1) {
      pages.push(1);
      if (start > 2) {
        pages.push('...');
      }
    }

    // Add the visible page range
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Always show last page if not in range
    if (end < totalPages) {
      if (end < totalPages - 1) {
        pages.push('...');
      }
      pages.push(totalPages);
    }

    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <div className="pagination-container-dash">
      <div className="pagination-info">
        صفحة {currentPage} من {totalPages}
      </div>
      <div className="pagination-controls-dash">
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="pagination-btn-dash"
        >
          ← السابق
        </button>
                
        <div className="pagination-pages-dash">
          {visiblePages.map((page, index) => (
            page === '...' ? (
              <span key={`ellipsis-${index}`} className="pagination-ellipsis-dash">
                ...
              </span>
            ) : (
              <button
                key={page}
                onClick={() => onPageChange(page)}
                className={`pagination-page-dash ${currentPage === page ? 'active' : ''}`}
              >
                {page}
              </button>
            )
          ))}
        </div>

        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="pagination-btn-dash"
        >
          التالي →
        </button>
      </div>
    </div>
  );
};

export default Pagination;